import { formatChangeValue } from 'src/utils/number/number'
import { switchCurrency, switchVolume } from 'src/utils/number/currency'

export const getValues = (item, currency) => {
  const volumePercent = formatChangeValue(item.volumePercent)
  const spread = item.spread === 0 ? '-' : `${formatChangeValue(item.spread)}%`
  const price = switchCurrency(currency, item)
  const volume = switchVolume(currency, item)

  return {
    volumePercent,
    price,
    volume,
    spread,
  }
}

export function parseSlug(slug) {
  const n = slug.lastIndexOf('-')
  return n !== -1 ? [slug.substring(0, n), slug.substring(n + 1)] : [slug]
}
